import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

// 2026-09-14 perf fix: /settings/public was being fetched independently by ~10 different
// components (ThemeModeContext, InstallPwaPrompt, MemberLayout, AuthFlow, etc.), all firing
// in parallel on every cold app boot - a burst of duplicate identical GET requests that
// competed for the WebView's connection limit on first launch. This shared TanStack Query
// hook dedupes them into exactly ONE network request per staleTime window, shared across
// every consumer, with instant cached reads on every subsequent mount/navigation.
export function usePublicSettings() {
  return useQuery({
    queryKey: ["public-settings"],
    queryFn: () => api.get("/settings/public").then((r) => r.data),
    staleTime: 60_000,
  });
}
